import React, { useState } from "react";
import styles from "./AutoAssignModal.module.css";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../firebase-config";
import closeIcon from "../../../../../assets/close.png";
import ButtonComponent from "../../../../../components/CssComponents/ButtonComponent/ButtonComponent";
import { notification } from "antd";

function UpdateTargetAmmount({
  isUpdateModal,
  setIsUpdateModal,
  fetchSalesData,
  data,
}) {
  const [targetNumber, setTargetNumber] = useState(data?.targetNumber || "");
  const [targetMonth, setTargetMonth] = useState(data?.targetMonth || "");
  const [targetYear, setTargetYear] = useState(data?.targetYear || "");

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!targetNumber || !targetMonth || !targetYear) {
      alert("Please fill all fields.");
      return;
    }

    try {
      if (!data?.id) {
        notification.error({
          message: "Error",
          description: "Target ID not found. Cannot update.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      const targetRef = doc(db, "targets", data.id);

      await updateDoc(targetRef, {
        targetNumber: parseInt(targetNumber),
        targetMonth: parseInt(targetMonth),
        targetYear: parseInt(targetYear),
        updatedAt: new Date(),
      });

      notification.success({
        message: "Target Updated",
        description: "Target amount updated successfully!",
        placement: "topRight",
        duration: 3,
      });
      fetchSalesData();
      setIsUpdateModal(false);
    } catch (error) {
      console.error("Error updating target:", error);
      notification.error({
        message: "Error updating target",
        description: error.message,
        placement: "topRight",
        duration: 3,
      });
    }
  };

  return (
    <div
      className={
        isUpdateModal
          ? `${styles.modal} ${styles.displayBlock}`
          : `${styles.modal} ${styles.displayNone}`
      }
    >
      <div className={styles.modalMain}>
        <button
          className={styles.closeBtn}
          onClick={() => setIsUpdateModal(false)}
        >
          <img src={closeIcon} alt="Close" />
        </button>
        <div className={styles.mainContent}>
          <div className={styles.title}>Update Target</div>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Number</div>
              <input
                type="number"
                className={styles.input}
                value={targetNumber}
                onChange={(e) => setTargetNumber(e.target.value)}
                placeholder="Enter target Amount"
                required
              />
            </div>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Month</div>
              <input
                type="number"
                disabled
                className={styles.input}
                value={targetMonth}
                onChange={(e) => setTargetMonth(e.target.value)}
                placeholder="Enter target month (1-12)"
                min="1"
                max="12"
                required
              />
            </div>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Year</div>
              <input
                type="number"
                disabled
                className={styles.input}
                value={targetYear}
                onChange={(e) => setTargetYear(e.target.value)}
                placeholder="Enter target year"
                required
              />
            </div>
            <ButtonComponent buttonText={"Update Target"} buttonType="submit" />
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateTargetAmmount;
